
export enum TripCategoryCd {
	OPERATIONAL = 'Operational',
	THIRD_PARTY_AD_HOC = 'ThirdPartyAdHoc',
	THIRD_PARTY_SCHEDULED = 'ThirdPartyScheduled',
	TRIP_EQUIPMENT_DROP = 'TripEquipmentDrop'}

